export enum AREA_CHART_FILTERS_FORM_FIELDS_NAMES {
  AREA_CHART_DATE_PERIOD = 'datePeriod',
}

export interface AreaChartFilterFormValues {
  [AREA_CHART_FILTERS_FORM_FIELDS_NAMES.AREA_CHART_DATE_PERIOD]: string;
}
